// import { DataNode } from 'antd/lib/tree';
import React from 'react';
import { MinusCircleFilled, PlusCircleFilled } from '@ant-design/icons';
import { MLAssessmentScore, SequenceStatusInfo } from '../annotation.types';
import { getMLScoreContent, prepareTreeAdditionalData } from '../Helpers';
import { Tooltip } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

type DataNode = any;

export const prepareTurbineTreeStructure = (turbine: string, requiredPath: string, sequenceStatuses: SequenceStatusInfo[]) => {
  const turbineTreeStructure: DataNode = {
    title: (
      <span>
        {turbine} {getTurbineAdditionalData(sequenceStatuses)}
      </span>
    ),
    key: requiredPath,
    switcherIcon,
    selectable: true,
    children: blades.map(blade => ({
      title: (
        <span>
          {blade.position} {getBladeAdditionalData(blade.position, sequenceStatuses)}
        </span>
      ),
      key: `${requiredPath}/${blade.position}`,
      selectable: true,
      switcherIcon,
      children: blade.sides.map(side => ({
        title: (
          <span>
            {side.value} {getSequenceAdditionalData(blade.position, side.key, sequenceStatuses)}
          </span>
        ),
        key: `${requiredPath}/${blade.position}/${side.key}`
      }))
    }))
  };

  return [turbineTreeStructure];
};

const getSequenceAdditionalData = (blade: string, side: string, sequenceStatuses: SequenceStatusInfo[]) => {
  const sequence = sequenceStatuses.find(x => x.blade === blade && x.bladeSide === side);

  if (sequence) {
    return (
      <>
        ({sequence.annotationsToBeTransferredCount}/{sequence.annotationsCount}){' '}
        {(sequence.haveQC || (sequence.mlAssessmentScore && sequence.mlAssessmentScore < MLAssessmentScore.MajorAdjustmentNeeded)) && (
          <Tooltip placement='left' title={getMLScoreContent(sequence.mlAssessmentScore)}>
            <FontAwesomeIcon icon={faExclamationTriangle} className='qc-issues' />
          </Tooltip>
        )}
      </>
    );
  }

  return '';
};
const getBladeAdditionalData = (position: string, sequenceStatuses: SequenceStatusInfo[]) => {
  let total = 0;
  let totalToBeTransferred = 0;
  sequenceStatuses.forEach(x => {
    if (x.blade === position) {
      totalToBeTransferred += x.annotationsToBeTransferredCount;
      total += x.annotationsCount;
    }
  });

  return (
    <>
      ({totalToBeTransferred}/{total})
    </>
  );
};

const getTurbineAdditionalData = (sequenceStatuses: SequenceStatusInfo[]) => {
  let total = 0;
  let totalToBeTransferred = 0;
  sequenceStatuses.forEach(x => {
    totalToBeTransferred += x.annotationsToBeTransferredCount;
    total += x.annotationsCount;
  });

  return (
    <>
      ({totalToBeTransferred}/{total})
    </>
  );
};

const switcherIcon = ({ expanded }: any) =>
  expanded ? <MinusCircleFilled style={{ color: '#321850' }} /> : <PlusCircleFilled style={{ color: '#321850' }} />;

const bladeSides = [
  {
    key: 'LeadingEdge',
    value: 'Leading Edge'
  },
  {
    key: 'PressureSide',
    value: 'Pressure Side'
  },
  {
    key: 'SuctionSide',
    value: 'Suction Side'
  },
  {
    key: 'TrailingEdge',
    value: 'Trailing Edge'
  }
];

const blades = [
  {
    position: 'A',
    sides: bladeSides
  },
  {
    position: 'B',
    sides: bladeSides
  },
  {
    position: 'C',
    sides: bladeSides
  }
];
